// from Webamp demo

const album = 'netBloc Vol. 24: tiuqottigeloot';

export const initialTracks = [
  {
    url: 'https://files.catbox.moe/nxpr8k.mp3',
    duration: 190.093061,
    metaData: {
      title: '916',
      artist: 'Aarayáh',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/ub6chj.mp3',
    duration: 190.093061,
    metaData: {
      title: 'Breach Of Trust (Original Mix)',
      artist: 'Dog On Acid',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/5v1tyy.mp3',
    duration: 190.093061,
    metaData: {
      title: 'Vapourise',
      artist: 'Sub Focus',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/1n2qlq.mp3',
    duration: 190.093061,
    metaData: {
      title: 'I believe in U <3',
      artist: 'Gneiss',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/k2wsvb.mp3',
    duration: 190.093061,
    metaData: {
      title: 'CHULO EDIT',
      artist: 'SLACK 1NE',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/2i6cf8.mp3',
    duration: 190.093061,
    metaData: {
      title: 'Barbie Dolls',
      artist: 'Felicia Arts',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/9u04vi.mp3',
    duration: 190.093061,
    metaData: {
      title: 'Follow me Please <3',
      artist: 'Gneiss',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/5jbmdi.mp3',
    duration: 190.093061,
    metaData: {
      title: 'Big Bad',
      artist: 'SLACK 1NE',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/u5q06b.mp3',
    duration: 322.612245,
    metaData: {
      title: 'Gneiss',
      artist: 'We Control The Sound',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/9zcbit.mp3',
    duration: 190.093061,
    metaData: {
      title: 'Facta',
      artist: 'Slope',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/taiajc.mp3',
    duration: 190.093061,
    metaData: {
      title: 'True Romance',
      artist: 'D-Bridge',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/m4olpr.mp3',
    duration: 190.093061,
    metaData: {
      title: 'Morning Lights',
      artist: 'Gneiss',
      album,
    },
  },
  {
    url: 'https://files.catbox.moe/sw0zst.mp3',
    duration: 190.093061,
    metaData: {
      title: 'Move Over',
      artist: 'Curbi',
      album,
    },
  },
];
